export default "__VITE_ASSET__B0W$u_Uf__"